import { createTheme } from "@mui/material/styles";
const baseTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#2E3A59" },
    secondary: { main: "#4A5A7A" },
    background: { default: "#f4f6f8", paper: "#fff" },
    primaryColor: "#2E3A59",
    white: "#fff",
    sidebar: {
      background: "#2E3A59", // Blue
      text: "#ffffff", // White
      hover: "rgba(255,255,255,0.1)",
      active: "#E31E25", // Red for selected
    },
  },
  typography: {
    fontFamily: '"IBM Plex Sans", sans-serif',
    h6: { fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        containedPrimary: {
          backgroundColor: "#2E3A59",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#1E2A45",
          },
        },
        root: { padding: "10px 20px" },
      },
    },
  },
  // Add SweetAlert styles here
  swal: {
    titleFont: "'IBM Plex Sans', sans-serif", // Retained same font family as MUI theme
    textFont: "'IBM Plex Sans', sans-serif", // Same font for text
    buttonColor: "#2E3A59", // Default button color
    buttonTextColor: "#fff", // Button text color
    buttonHoverColor: "#1E2A45", // Button hover color
    backgroundColor: "#fff", // Background color
    confirmButtonColor: "#2E3A59", // Confirm button color
    cancelButtonColor: "#fff", // Cancel button color
  },
});
export default baseTheme;
// Optional helper to switch dark/light at runtime:
export const getTheme = (mode = "light") =>
  createTheme({
    ...baseTheme,
    palette: { ...baseTheme.palette, mode },
  });
